import styled from 'styled-components';

export const Wrapper = styled.div`
  flex: 1
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: space-between;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 1rem;
  }
`;

export const WrapperTable = styled.div`
  table {
    border-collapse: collapse;
    text-align: center;
    width: 100%;
  }

  th {
    padding: 8px 16px;
    border: 1px solid #ddd;
    font-weight: bold;
  }

  td {
    padding: 8px 16px;
    border: 1px solid #ddd;
  }

  .meta {
    background-color: #57d9a3;
    color: white;
  }

  @media (max-width: 768px) {
    width: 100%;
  }
`;

export const WrapperForm = styled.div`
  display: flex;
  flex-direction: row;
  gap: 1rem;

  margin: auto 0;

  max-width: fit-content;

  > * {
    flex: 1;
  }

  @media (max-width: 768px) {
    flex-direction: column;
  }
`;
